import { createAction, props } from '@ngrx/store';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadProductStartingAges = createAction('[StaticData] Load ProductStartingAges');

export const loadProductStartingAgesSuccess = createAction(
  '[StaticData] Load ProductStartingAges Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadProductStartingAgesFailure = createAction('[StaticData] Load ProductStartingAges Failure', props<{ error: any }>());
